import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'services/authentication/AuthenticationContext';

// Rename the name of the function:
const EmailLayoutList: React.FC = () => {
    const { t } = useTranslation();
    const { activeFeatures } = useAuthContext();

    // Filter the list on the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionParams = !isEnvironmentSelected && selectedDivision ? { 'division_scope': selectedDivision.id } : {};

    // Specify the options of this list:
    const query = {
        endpoint: 'get_email_layout_list',
        defaultParams: { 'deleted': false, ...divisionParams },
        object: 'email_layout'
    }
    const objectName = 'email.email_layout.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const openPageUrl = 'settings/features/email/layout-library';
    const onRowClick = 'detailPage';
    const detailPageUrl = 'settings/features/email/layout';

    // Render the layout name
    const renderName = (row: any) => {
        const parts: string[] = [];

        // Name (als die er is)
        if (row.name) {
            parts.push(row.name);
        }

        // Alleen divisions tonen als feature actief is én er een division is
        if (activeFeatures.includes('divisions') && row.division_name) {
            parts.push(row.division_name);
        }

        // Standaard label
        if (row.is_default) {
            parts.push(`(${t('email.email_layout.default_label')})`);
        }

        return <>{parts.join(' - ')}</>;
    };

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        {
            width: '1fr',
            field: 'name',
            label: 'email.email_layout.name_label',
            render: (_, row) => renderName(row),
        }
    ];

    return (
        <AbstractList
            key={!isEnvironmentSelected && selectedDivision ? selectedDivision.id : 'environment'}
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            openPageUrl={openPageUrl}
            detailPageUrl={detailPageUrl}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default EmailLayoutList;